import styled from 'styled-components';

import Checkbox from '../Checkbox';

const Switch = styled(Checkbox)`
  position: relative;
  appearance: none;
  outline: none;
  width: 40px;
  height: 24px;
  background-color: #ffffff;
  border: 1px solid #d9dadc;
  border-radius: 50px;
  box-shadow: inset -16px 0 0 0 #ffffff;
  transition-duration: 200ms;

  &:after {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    width: 21px;
    height: 21px;
    background-color: transparent;
    border-radius: 50%;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
  }

  &:checked {
    border-color: #4ed164;
    box-shadow: inset 16px 0 0 0 #4ed164;
  }

  &:checked:after {
    left: 16px;
    box-shadow: -2px 4px 3px rgba(0, 0, 0, 0.05);
  }
`;

export default Switch;
